import { createFileRoute } from '@tanstack/react-router';
import PocketPage from '@/pages/static/PocketPage';

export const Route = createFileRoute('/pocket')({
  component: PocketPage,
});
